import { axiosClient, getCSRFToken } from 'www/utils'

function sendClubData({ data, couponRequestId } = {}) {
  return new Promise((resolve, reject) => {
    axiosClient({
      data,
      method: 'POST',
      url: `/ajax/club/coupon_request/${couponRequestId}/online_payment/`,
      headers: {
        'X-CSRFToken': getCSRFToken(),
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(response => resolve(response.data))
      .catch(({ response }) => reject(response?.data || {})) // eslint-disable-line prefer-promise-reject-errors
  })
}

export default sendClubData
